import DeleteApplication from './DeleteApplication';
export default DeleteApplication;
